import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Select, Upload } from "antd";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { PostDocumentApi } from "api/getQuiz";
import {
  openNotificationWithIcon,
  validateMessages,
} from "../../../../Function";

const ModalCreateDoc = ({
  open,
  onCancel,
  arrTypeQuestion,
  setSelectedGroup,
  fetchListExamMaterials,
}) => {
  const [form] = Form.useForm();
  const [fileDocument, setFileDocument] = useState([]);

  useEffect(() => {
    form.resetFields();
    setFileDocument([]);
  }, [open]);

  const onFinish = (values) => {
    var FormData = require("form-data");
    var data = new FormData();
    data.append("question_type", values.question_type);
    if (fileDocument != undefined) {
      fileDocument.forEach((element) => {
        data.append("file", element.originFileObj);
      });
    }
    PostDocumentApi(data)
      .then((res) => {
        openNotificationWithIcon("success", res.data.message);
        form.resetFields();
        setFileDocument([]);
        setSelectedGroup(values.question_type);
        onCancel();

        fetchListExamMaterials({
          question_type: values.question_type,
        });
      })
      .catch((err) => {
        if (err.data.error) {
          openNotificationWithIcon("error", err.data.error);
        }
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleChangeUpload = (info) => {
    let thisFileList = [...info.fileList];
    if (thisFileList.length > 0) {
      setFileDocument([thisFileList[thisFileList.length - 1]]);
    }
    if (thisFileList.length === 0) {
      setFileDocument([]);
      form.setFieldsValue({
        file: undefined,
      });
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Tạo tài liệu"
      style={{ minWidth: "300px" }}
      width={500}
      footer={false}
      bodyStyle={{ paddingTop: 6 }}
      className={"site-drawer-render-in-current-wrapper"}
      maskClosable={false}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        validateMessages={validateMessages}
      >
        <Row>
          <Col span={20} offset={2}>
            <Form.Item
              label="Nhóm thi"
              name="question_type"
              rules={[{ required: true }]}
            >
              <Select>
                {arrTypeQuestion &&
                  arrTypeQuestion.map((item, index) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.note} ({item.loai_cau_hoi})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={20} offset={2}>
            <Form.Item
              label="File tài liệu"
              name="file"
              rules={[
                { required: true, message: "Vui lòng tải lên tài liệu." },
              ]}
            >
              <Upload
                accept=".pdf"
                onChange={handleChangeUpload}
                fileList={fileDocument}
                maxCount={1}
                // className={"styleUploadExcel"}
                beforeUpload={(file) => {
                  return false;
                }}
              >
                <Button type="dashed" htmlType="button">
                  Tải lên
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item wrapperCol={{ offset: 9, span: 12 }}>
          <Button type="success" htmlType="submit" className={"m-2"}>
            Tạo
          </Button>
          <Button onClick={onCancel}>Thoát</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalCreateDoc;
